import { StringUtils } from './siteUtils'

export const DEFAULT_INSTALLATION_MODE = 'integrated'

export const LandingType = {
  Unassigned: 'unassigned',
  Assigned: 'assigned',
  DigitalRetail: 'dr',
  OEM: 'oem'
}

export const formatVehicleParam = param => {
  return StringUtils.getStringValue(param)?.replaceAll('+', ' ')
}
